import { inject, Injectable } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';

/**
 * @description
 * Abstraction service over Ionic's Platform functionality.
 * Exposes specific flags and lifecycle methods to determine the current
 * runtime environment (e.g., iOS, Android, Hybrid PWA/Native).
 */
@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  private readonly platform = inject(Platform);

  public readonly isHybrid: boolean;
  public readonly isIos: boolean;
  public readonly isAndroid: boolean;

  constructor() {
    this.isHybrid = this.platform.is('hybrid');
    this.isIos = this.platform.is('ios');
    this.isAndroid = this.platform.is('android');
  }

  /**
   * Returns a promise that resolves when the platform is ready and native plugins are available.
   *
   * @returns {Promise<string>} A promise that resolves to the platform runtime (e.g., 'dom' or 'cordova') once initialization is complete.
   */
  public ready(): Promise<string> {
    return this.platform.ready();
  }
}
